import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import { toLocale } from '@/util/dateutils'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'logauditoria',
    ...crudState()
  }),
  getters: {
    ...crudGetters,
    allLoc (state) {
      for (let i = 0; i < state.all.length; i++) {
        state.all[i] = toLocale(state.all[i], 'fechahora', 'fechahoraloc')
        // ar dateDate = new Date(state.all[i].fechahora + ' GMT-0000')
        // state.all[i].fechahoraloc = dateDate.toLocaleString()
      }
      return state.all
    }
  },
  mutations: {
    ...crudMutations
  },
  actions: {
    ...crudActions
  }
}
